export enum ReadingStatus {
  Normal = 'normal',
  Risk = 'risk',
  Critical = 'critical',
}
